<template>
  <div class="new-quota-main">
    <el-form
      :model="newTemplateList"
      label-position="center"
      :rules="rules"
      label-width="120px"
      ref="newTemplateList"
    >
      <div>
        <el-row>
          <el-col :span="12">
          <el-form-item :label="$translate('lang.E3202103110001', { defaultText: '租户代码' })"  prop="tenantCode">
            <el-select class="new-quota-main-item item-right"  v-model="newTemplateList.tenantCode" @change="setTenantName">
            <el-option  v-for="item in tenantList"  :key="item.tenantCode" :label="item.tenantCode" :value="item.tenantCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
          <el-col :span="12">
            <el-form-item :label="$translate('lang.E3202103110002', { defaultText: '租户名称' })" prop="tenantName">
              <el-input  class="new-quota-main-item item-right" v-model="newTemplateList.tenantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$translate('lang.E3202103120003', { defaultText: '文件存储(MB)' })" prop="maxTotalFileSize">
              <el-input  class="new-quota-main-item item-right" v-model.number="newTemplateList.maxTotalFileSize"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$translate('lang.E3202103120001', { defaultText: '总标识量' })" prop="maxIdentityAmount" :title="$translate('lang.E3202103120001', { defaultText: '总标识量' })">
              <el-input  class="new-quota-main-item item-right" v-model.number="newTemplateList.maxIdentityAmount" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$translate('lang.E3202103120004', { defaultText: '日解析量' })" prop="maxDailyParsingAmount">
              <el-input  class="new-quota-main-item item-right" v-model.number="newTemplateList.maxDailyParsingAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$translate('lang.E3202103120005', { defaultText: '日注册量' })" prop="maxDailyRegistingAmount">
              <el-input class="new-quota-main-item item-right" v-model.number="newTemplateList.maxDailyRegistingAmount" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
import config from '../quotaConfig.js';
export default {
    props: ['templateList', 'tenantList'],
    data() {
        const validatorFile = (rule, value, callback) => {
            if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
            } else {
                callback(new Error(this.$translate('lang.E3202103120007', { defaultText: '请输入文件存储(正整数)' })));
            }
        };
        const validatorMaxAmount = (rule, value, callback) => {
            if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
            } else {
                callback(new Error(this.$translate('lang.E3202103120008', { defaultText: '请输入总标示量(正整数)' })));
            }
        };
        const validatorDayAmount = (rule, value, callback) => {
            if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
            } else {
                callback(new Error(this.$translate('lang.E3202103120009', { defaultText: '请输入日解析量(正整数)' })));
            }
        };
        const validatorDayRegAmount = (rule, value, callback) => {
            if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
            } else {
                callback(new Error(this.$translate('lang.E3202103120010', { defaultText: '请输入日注册量(正整数)' })));
            }
        };
        return {
            config: config,
            newTemplateList: this.templateList,
            rules: {
                tenantCode: [{ required: true, message: this.$translate('lang.E3202103090024', { defaultText: '请选择租户代码' }) }],
                maxTotalFileSize: [
                    {
                        type: 'number',
                        required: true,
                        message: this.$translate('lang.E3202103120007', { defaultText: '请输入文件存储(正整数)' }),
                        trigger: 'blur'
                    },
                    { validator: validatorFile, trigger: 'blur' }
                ],
                maxIdentityAmount: [
                    {
                        type: 'number',
                        required: true,
                        message: this.$translate('lang.E3202103120008', { defaultText: '请输入总标示量(正整数)' }),
                        trigger: 'blur'
                    },
                    { validator: validatorMaxAmount, trigger: 'blur' }
                ],
                maxDailyParsingAmount: [
                    {
                        type: 'number',
                        required: true,
                        message: this.$translate('lang.E3202103120009', { defaultText: '请输入日解析量(正整数)' }),
                        trigger: 'blur'
                    },
                    { validator: validatorDayAmount, trigger: 'blur' }
                ],
                maxDailyRegistingAmount: [
                    {
                        type: 'number',
                        required: true,
                        message: this.$translate('lang.E3202103120010', { defaultText: '请输入日注册量(正整数)' }),
                        trigger: 'blur'
                    },
                    { validator: validatorDayRegAmount, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        setTenantName(value) {
            this.tenantList.map(item => {
                if (item.tenantCode === value) {
                    this.newTemplateList.tenantName = item.tenantName;
                }
            });
        }
    }
};
</script>
<style lang="less">
.new-quota-main{
  .el-form-item__label{
        padding: 0 10px 0 0;
  }
  .new-quota-main-item{
    width: 180px;
  }
  .el-form-item {
    margin-bottom: 26px;
  }
}
</style>